import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  serverSideSupport: {
    id: 'studio.jx3A4P',
    defaultMessage: 'Server-side',
  },
  serverSideSupportTooltip: {
    id: 'studio.CwuT4e',
    defaultMessage: 'This action is supported on the server as well, including during cronjobs',
  },
});
